module.exports = __webpack_public_path__ + "img/icon-line-footer.09d45c83.svg";